import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Textarea, TextField } from '@zep/ui';
export const AdditionalComment = ({
  name
}: {
  name: string;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    register,
    watch
  } = useFormContext();
  const value = watch(name);
  return <TextField id="additional-comment" label={t('subscription:unsubscribe.additionalComment.label')} rightSlot={`${value.length}/300`} data-sentry-element="TextField" data-sentry-component="AdditionalComment" data-sentry-source-file="AdditionalComment.tsx">
      <Textarea id="additional-comment" rows={3} placeholder={t('subscription:unsubscribe.additionalComment.placeholder')} maxLength={300} {...register(name)} isFullWidth data-sentry-element="Textarea" data-sentry-source-file="AdditionalComment.tsx" />
    </TextField>;
};